import request from '@/utils/request'
import debugLog from '@/utils/debugLog'

export function getCustomers(params) {
  // debugLog(params)
  return request({
    url: '/customers',
    method: 'get',
    params: params
  })
}

export function getCustomer(id) {
  debugLog(id)
  return request({
    url: `/customers/${id}`,
    method: 'get'
  })
}

export function patchCustomer(record) {
  const rec_id = record.id
  delete record.id
  return request({
    url: '/customers/' + rec_id,
    method: 'patch',
    data: {customer: record}
  })
}

export function postCustomer(record) {
  delete record.id
  return request({
    url: '/customers/',
    method: 'post',
    data: {customer: record}
  })
}
